'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', 'px;\n'], ['\n  height: ', 'px;\n']);

var _propTypes = require('prop-types');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NitroPlaceholder = _styledComponents2.default.div(_templateObject, function (props) {
  return props.size;
});

NitroPlaceholder.displayName = 'NitroPlaceholder';
NitroPlaceholder.defaultProps = {
  size: 48
};

NitroPlaceholder.propTypes = {
  className: _propTypes.PropTypes.string,
  size: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.number, _propTypes.PropTypes.string])
};

exports.default = NitroPlaceholder;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-placeholder/NitroPlaceholder.js
// module id = 3026
// module chunks = 4